import { InvoiceListBaseModel } from "./InvoiceListBaseModel";
export class InvoicingListModel extends InvoiceListBaseModel {}
